import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Radio from 'apollo-react/components/Radio';
import RadioGroup from 'apollo-react/components/RadioGroup';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { downloadBulkImportFile } from '../../actions/BulkImportActions';
import { BULK_IMPORT_APIS, DOWNLOAD_TEMPLATE_TYPES } from '../../constants/MasterSetupConstants';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import ButtonLoader from '../general/Login/LoginLoader';
import {
  getCurrentSavedSearchName,
  getSavedSearchResultsParams,
} from '../SavedSearchesTable/selectors';

const useStyles = makeStyles({
  modal: {
    minWidth: 400,
    zIndex: 1200,
  },
  button: {
    width: 105,
  },
});

const DownloadTemplateModal = ({ setModalOpen, apiParams, isWorkflowMasterSetup }) => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();

  const [downloadType, setDownloadType] = useState(DOWNLOAD_TEMPLATE_TYPES[0].value);
  const [isDownloadLoading, setDownloadLoading] = useState(false);

  const currentSavedSearchName = useFormSelector(getCurrentSavedSearchName);
  const searchParams = useFormSelector(getSavedSearchResultsParams, {
    key: `${apiParams.entityKey}.${currentSavedSearchName}`,
  });

  const downloadTemplate = async () => {
    setDownloadLoading(true);

    const searchData = { ...searchParams, savedSearchName: searchParams.searchName };
    delete searchData.searchName;

    await dispatch(
      downloadBulkImportFile({
        downloadType: BULK_IMPORT_APIS.DOWNLOAD_TEMPLATE,
        isWorkflowMasterSetup,
        apiProps: {
          ...apiParams,
          searchData: downloadType === DOWNLOAD_TEMPLATE_TYPES[1].value ? searchData : null,
        },
      })
    );

    setDownloadLoading(false);
    setModalOpen(false);
  };

  const buttonProps = [
    {
      label: translateString('Cancel'),
    },
    {
      label: isDownloadLoading ? <ButtonLoader size={26} /> : translateString('Download'),
      onClick: downloadTemplate,
      disabled: isDownloadLoading,
      className: isDownloadLoading ? classes.button : undefined,
    },
  ];

  return (
    <Modal
      open
      variant="default"
      onClose={() => setModalOpen(false)}
      title={translateString('Download Template')}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={buttonProps}
    >
      <RadioGroup value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
        {DOWNLOAD_TEMPLATE_TYPES.map((item) => (
          <Radio key={item.value} value={item.value} label={translateString(item.label)} />
        ))}
      </RadioGroup>
    </Modal>
  );
};

export default DownloadTemplateModal;
